import { withStyles } from "@material-ui/core";
const styles = (theme) => ({
  textStyle: {
    "& span": {
      margin: "3px 0px",
      fontWeight: theme.textFontSize,
      fontSize: "12px",
      color: theme.gridTextColor,
    },
    display: "flex",
    flexDirection: "column",
  },
});
const OptimizationInfo = ({ classes }) => {
  return (
    <div className={classes.textStyle}>
      <span>
        <b>Optimization considers:</b>
      </span>
      <span>1. Shippers' Ready & Close Time</span>
      <span> 2. Required PSE (Pallet Space Equivalents)</span>
      <span>3. Each driver's ETA at remaining & potential stops </span>
      <span>4. Expected future space and weight</span>
    </div>
  );
};
export default withStyles(styles)(OptimizationInfo);
